import { Button, Grid, Typography } from "@mui/material";
import { ButtonGroupFormElementExecution } from "../../../../types";

export enum ButtonGroupFunction {
  GOTO_STEP = "GOTO_STEP",
  NEXT_STEP = "NEXT_STEP",
  PREV_STEP = "PREV_STEP",
  SUBMIT_TASK = "SUBMIT",
}

export type ButtonGroupSettings = {
  id: string;
  label: string;
  assignment: ButtonGroupFunction;
  data: number | string | undefined;
  variant?: "contained" | "outlined" | "text";
};

export const TaskButtonGroupFormComponent = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ...props
}: {
  disabled: boolean;
  onClick: (assignment: ButtonGroupSettings) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  execution: any;

  disableType?: Partial<Record<ButtonGroupFunction, boolean>>;
}) => {
  const settings = props.execution?.settings;
  const alignment = props.execution?.alignment;
  // Determine justifyContent based on alignment prop
  const getJustifyContent = () => {
    switch (alignment) {
      case "left":
        return "flex-start";
      case "right":
        return "flex-end";
      case "center":
      default:
        return "center";
    }
  };

  const label = (props.execution as ButtonGroupFormElementExecution).label;

  return (
    <Grid
      container
      spacing={2}
      justifyContent={getJustifyContent()}
      sx={{ px: 2, pt: 3 }}
    >
      {settings?.map((settings: ButtonGroupSettings) => (
        <Grid
          key={settings.id}
          sx={{ display: "flex" }}
          size={{
            xs: 12,
            sm: 4,
          }}
        >
          <Button
            variant={settings.variant || "contained"}
            disabled={
              props.disabled ||
              (props.disableType &&
                props.disableType[settings.assignment] === true)
            }
            onClick={() => props.onClick(settings)}
            fullWidth
            sx={{ flexGrow: 1 }}
          >
            {settings.label}
          </Button>
        </Grid>
      ))}
      <Grid size={12}>
        {label && label != "" && (
          <Typography
            variant={"caption"}
            textAlign={alignment || "center"}
            sx={(theme) => ({
              color: theme.palette.grey[600],
              display: "block",
            })}
          >
            {(props.execution as ButtonGroupFormElementExecution).label}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
